export const FILTER_CHANGE_ACTION = 'FILTER_CHANGE_ACTION';
export const FILTER_QUERY = 'FILTER_QUERY';
export const FILTER_RECEIVE = 'FILTER_RECEIVE';
export const FILTER_FETCH_FAILED = 'FILTER_FETCH_FAILED';
export const FILTER_STARTUP = 'FILTER_STARTUP';
export const FILTER_EXPAND_SECTION = 'FILTER_OPEN_SECTION';
export const FILTER_TOGGLE_MOBILE = 'FILTER_TOGGLE_MOBILE';
export const SET_HORIZONTAL_FILTER = 'SET_HORIZONTAL_FILTER';
export const PROPERTY_SEARCH_ACTION = 'PROPERTY_SEARCH_ACTION';
export const PROPERTY_SEARCH_CORE_COMPLETE = 'PROPERTY_SEARCH_CORE_COMPLETE';
export const PROPERTY_SEARCH_SECTION_COMPLETE =
  'PROPERTY_SEARCH_SECTION_COMPLETE';
export const PROPERTY_SEARCH_COMPLETE = 'PROPERTY_SEARCH_COMPLETE';
export const PROPERTY_SEARCH_TOGGLE_SECTION = 'PROPERTY_SEARCH_TOGGLE_SECTION';
export const COMPARE_PROPERTY = 'COMPARE_PROPERTY';
export const COMPARE_PROPERTIES = 'COMPARE_PROPERTIES';

export const filterQuery = query => ({
  query,
  type: FILTER_QUERY,
});

export const expandSection = name => ({
  name,
  type: FILTER_EXPAND_SECTION,
});

export const filterReceive = (data, categoryData) => ({
  data,
  categoryData,
  type: FILTER_RECEIVE,
});

export const filterFetchFailed = ({ error }, categoryId) => ({
  error,
  categoryId,
  type: FILTER_FETCH_FAILED,
});

export const filterChangeAction = (categoryId, data) => ({
  categoryId,
  ...data,
  type: FILTER_CHANGE_ACTION,
});

export const compareProperty = propertyId => ({
  propertyId,
  type: COMPARE_PROPERTY,
});

export const compareProperties = propertyIds => ({
  propertyIds,
  type: COMPARE_PROPERTIES,
});

export const toggleMobile = open => ({
  open,
  type: FILTER_TOGGLE_MOBILE,
});

export const setHorizontalFilter = show => ({
  show,
  type: SET_HORIZONTAL_FILTER,
});

export const propertySearch = inputValue => ({
  inputValue,
  type: PROPERTY_SEARCH_ACTION,
});

export const propertySearchToggleExpansion = name => ({
  name,
  type: PROPERTY_SEARCH_TOGGLE_SECTION,
});

export const propertySearchComplete = (
  filteredCore,
  filteredSections,
  filteredValues,
  expandedSections
) => ({
  filteredCore,
  filteredSections,
  filteredValues,
  expandedSections,
  type: PROPERTY_SEARCH_COMPLETE,
});

export default {
  filterQuery,
  expandSection,
  filterReceive,
  filterFetchFailed,
  filterChangeAction,
  toggleMobile,
  propertySearch,
  propertySearchComplete,
  propertySearchToggleExpansion,
  compareProperty,
  compareProperties,
  setHorizontalFilter,
};
